export const NOTIFICATION_DROPDOWN_REFRESH = "NOTIFICATION_DROPDOWN_REFRESH"
export const NOTIFICATION_DROPDOWN_REFRESH_SUCCESS = "NOTIFICATION_DROPDOWN_REFRESH_SUCCESS"
export const NOTIFICATION_DROPDOWN_REFRESH_ERROR = "NOTIFICATION_DROPDOWN_REFRESH_ERROR"
